// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__253I9","footer":"ModalCreateQualiphyProcedure_footer__2paBW","additionData":"ModalCreateQualiphyProcedure_additionData__2jsqI"};